'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Linkify = require('./components/Linkify');

var _Linkify2 = _interopRequireDefault(_Linkify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Linkify2.default;